import { SpotIcon, StyledCard } from "@components";
import { theme } from "@utils";
import { Divider, Progress, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LineProvider from "./Line";
import {
  IChartCoupon,
  IClientInfo,
  IClinicHcp,
  IClinicVisualData,
  ICouponVisualData,
} from "@interfaces";
import { region_towship } from "@configs";
interface IProps {
  info: {
    data: IChartCoupon[];
    loading: boolean;
  };
  region?: string;
  handleFilterRegion: (value: string) => void;
}
export const ClinicCount = ({ info: { data, loading }, region, handleFilterRegion }: IProps) => {
  const { t } = useTranslation();
  const handleSelect = (value: any) => {
    handleFilterRegion(value);
  };
  return (
    <StyledCard loading={loading} minwidth={700}>
      <header>
        <h5>{t("page.provider_counts")}</h5>
        <Select placeholder="select region" onChange={handleSelect} value={region}>
          {Object.keys(region_towship).map((item) => (
            <Select.Option value={item} key={item}>
              {t(`page.${item}`)}
            </Select.Option>
          ))}
        </Select>
      </header>
      <Divider />
      <section className="clinic-content">
        <LineProvider data={data} />
      </section>
    </StyledCard>
  );
};
interface ICircleProps {
  patient: {
    data: IClinicHcp | undefined;
    loading: boolean;
  };
}
export const ClinicCircleCount = ({ patient: { data, loading } }: ICircleProps) => {
  const { t } = useTranslation();
  if (data === null || data === undefined) {
    return null;
  }
  return (
    <StyledCard loading={loading}>
      <header>
        <div>
          <p>{t("page.clinic")}</p>
          <h5>{t("page.health_care_person_count")}</h5>
        </div>
      </header>
      <Divider />
      <section className="content">
        <Progress
          type="circle"
          percent={data?.totalCount || 0}
          strokeColor={theme.colors.main}
          size={200}
          format={() => (
            <>
              {" "}
              <span className="progress-inner-text">Total Clinic</span>
              <br />
              <span className="number">{data?.totalCount}</span>
            </>
          )}
        />
      </section>
      <Divider />
      <footer>
        <div>
          <SpotIcon color={theme.colors.orange} />
          <p>{t("page.redeem")}</p>
          <p>{data?.redeemedCount}</p>
        </div>
        <div>
          <SpotIcon color={theme.colors.white} />
          <p>{t("page.unredeem")}</p>
          <p>{data?.unredeemedCount}</p>
        </div>
      </footer>
    </StyledCard>
  );
};
